import React from 'react';
import { observer } from 'mobx-react';

import { publicationRegisterStore } from '@stores/publicationRegisterStore';

import styles from '../PublicationRegisterDrawer.module.scss';

export const ReportInfo = observer(() => {
  const { reportPackageInfo } = publicationRegisterStore;

  return (
    <>
      <p className={styles.subtitle}>Информация об отчете</p>
      <ul className={styles.list}>
        <li>
          Код версии отчетной формы: <span>{reportPackageInfo.reportVersionCode}</span>
        </li>
        <li>
          Наименование версии отчетности: <span>{reportPackageInfo.reportVersionName}</span>
        </li>
        <li>
          Описание: <span>{reportPackageInfo.reportDescription}</span>
        </li>
        <li>
          Статус: <span>{reportPackageInfo.reportPublishStatus}</span>
        </li>
      </ul>
    </>
  );
});
